<template>
  <FormRow :label="fieldTypeInfo.name" v-if="isFieldAvailable" :helpTip="fieldTypeInfo.description || ''">

    <div v-if="editing">
      <FormSelect v-if="isFieldTypeSelect" :options="fieldLookup" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />
      <FormMultiSelect v-if="isFieldTypeMultiSelect" :options="fieldLookup" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />

      <FormMultiSelect v-if="isFieldTypeTagList" :taggable="true" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />

      <FormSelect v-if="isFieldTypeDayOfMonth" :options="dayOfMonthLookup" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />
      <FormCheckbox v-if="isFieldTypeBoolean" :value="fieldValue" @change="updateFieldValue" :note="fieldTypeInfo.note" />

      <div class="row no-gutters" v-if="isFieldTypeDayOfYear">
        <div class="col-6 pr-2">
          <FormSelect :options="yearlyDayOfMonthLookup" :value="yearlyDayOfMonthValue" @input="updateYearlyDayFieldValue" prepend="Day" />
        </div>
        <div class="col-6 pl-2">
          <FormSelect :options="yearlyMonthLookup" :value="yearlyMonthValue" @input="updateYearlyMonthFieldValue" prepend="Month" />
        </div>
      </div>

      <FormTime v-if="isFieldTypeTime" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />

      <FormInputText ref="inputCurrencyField" type="number" v-if="isFieldTypeCurrency" :value="fieldValue" @input="updateFieldValue" prepend="$" :note="fieldTypeInfo.note" @blur="$emit('blur', $event)" @focus="$emit('focus', $event)" />
      <FormInputText ref="inputNumberField" type="number" v-if="isFieldTypeNumber" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" @blur="$emit('blur', $event)" @focus="$emit('focus', $event)" />
      <FormInputText ref="inputTextField" type="text" v-if="isFieldTypeText" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" @blur="$emit('blur', $event)" @focus="$emit('focus', $event)" />
      <FormInputTextArea ref="inputTextAreaField" v-if="isFieldTypeTextArea" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" :showCharacterCount="showCharacterCount" :rows="10" @blur="$emit('blur', $event)" @focus="$emit('focus', $event)" />

      <AutomationUserListField v-if="isFieldTypeUserList" :editable="true" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />
      <AutomationUserGroupListField v-if="isFieldTypeUserGroupList" :editable="true" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />
      <AutomationPermissionListField v-if="isFieldTypePermissionList" :editable="true" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />
      <FormLabelTag v-if="isFieldTypeLabelList" :editable="true" :labelType="fieldLabelType" :value="fieldValue" @input="updateFieldValue" :note="fieldTypeInfo.note" />


    </div>

    <div v-if="!editing">
      <FormStaticLabel>
        <div v-if="!isFieldTypeTextArea">{{displayFieldValue}}</div>
        <div v-if="isFieldTypeTextArea" v-html="displayFieldValue"></div>

        <AutomationUserListField v-if="isFieldTypeUserList" :editable="false" :value="fieldValue" />
        <AutomationUserGroupListField v-if="isFieldTypeUserGroupList" :editable="false" :value="fieldValue"  />
        <AutomationPermissionListField v-if="isFieldTypePermissionList" :editable="false" :value="fieldValue"  />
        <LabelTags v-if="isFieldTypeLabelList" :labelList="fieldValue"  />

        <IconBoolean v-if="isFieldTypeBoolean" :value="fieldValue" :displayFalse="true" />
      </FormStaticLabel>

    </div>
    
    
  </FormRow>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import AutomationUserListField from '@/modules/automations/components/automationUserListField'
import AutomationUserGroupListField from '@/modules/automations/components/automationUserGroupListField'
import AutomationPermissionListField from '@/modules/automations/components/automationPermissionListField'

import { AutomationFieldTypes } from '@/store/types'

export default {
  name: 'AutomationComponentField',
  components: {
    AutomationUserListField,
    AutomationUserGroupListField,
    AutomationPermissionListField
  },
  props: {
    fieldTypeInfo: Object,
    componentFieldValueList: Array,
    editing: Boolean
  },
  computed: {
    isFieldTypeSelect() {
      if(this.fieldTypeInfo.fieldType == AutomationFieldTypes.enum && !this.fieldTypeInfo.isMultiSelect)
        return true
      return false
    },
    isFieldTypeMultiSelect() {
      if(this.fieldTypeInfo.fieldType == AutomationFieldTypes.enum && this.fieldTypeInfo.isMultiSelect)
        return true
      return false
    },
    isFieldTypeTime() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.time
    },
    isFieldTypeDayOfMonth() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.dayOfMonth
    },
    isFieldTypeDayOfYear() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.dayOfYear
    },
    isFieldTypeCurrency() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.currency
    },
    isFieldTypeNumber() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.number
    },
    isFieldTypeText() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.text
    },
    isFieldTypeTextArea() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.textArea
    },
    isFieldTypeTagList() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.tagList
    },
    isFieldTypeUserList() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.userList
    },
    isFieldTypeUserGroupList() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.userGroupList
    },
    isFieldTypePermissionList() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.permissionList
    },
    isFieldTypeLabelList() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.labelList
    },
    isFieldTypeBoolean() {
      return this.fieldTypeInfo.fieldType == AutomationFieldTypes.boolean
    },
    showCharacterCount() {
      return !!this.fieldTypeInfo.displayCharacterCount
    },
    fieldLookup() {
      return Object.keys(this.fieldTypeInfo.fieldEnumLookup).map(enumKey => {
        return {
          name: this.fieldTypeInfo.fieldEnumLookup[enumKey],
          value: enumKey
        }
      })
    },
    fieldValue() {
      let fieldSetting = (this.componentFieldValueList || []).find(fieldValue => fieldValue.field == this.fieldTypeInfo.field)
      if(fieldSetting) {

        // Validate value
        let requiresArray = false
        if(this.isFieldTypeLabelList || this.isFieldTypePermissionList || this.isFieldTypeUserGroupList || this.isFieldTypeUserList || this.isFieldTypeTagList)
          requiresArray = true
        
        if(requiresArray && !_.isArray(fieldSetting.value))
          fieldSetting.value = []

        return fieldSetting.value
      }
      return null
    },
    fieldLabelType() {
      return this.fieldTypeInfo.labelType
    },
    isFieldAvailable() {
      // Check if has any dependencies / requirements
      if(this.fieldTypeInfo.requires) {
        let requireList = Object.keys(this.fieldTypeInfo.requires).map(requireField => {
          return {
            field: requireField,
            value: this.fieldTypeInfo.requires[requireField]
          }
        })

        let requirementsMet = requireList.every(requireInfo => {
          let otherField = this.componentFieldValueList.find(otherField => otherField.field == requireInfo.field)
          if(otherField) {
            // If the require value is an array, can be any
            if(_.isArray(requireInfo.value)) {
              return requireInfo.value.includes(otherField.value)
            } else {
              return requireInfo.value == otherField.value
            }
          }

          return false
        })

        return requirementsMet
      }

      return true
    },
    dayOfMonthLookup() {
      let outputLookup = []
      for(let i=1; i<=31; i++)
        outputLookup.push({ value: i, name: '' + i })

      outputLookup.push({ value: 'eom', name: 'End of Month' })
        
      return outputLookup
    },
    yearlyDayOfMonthLookup() {
      // Uses current year
      // Leap years will be different, but whatever, users shouldn't be selecting 29th Feb for any day of year automations
      let daysInMonth = moment(this.fieldValue).local(true).daysInMonth()

      let outputLookup = []
      for(let i=1; i<=daysInMonth; i++)
        outputLookup.push({ value: i, name: '' + i })
        
      return outputLookup
    },
    yearlyMonthLookup() {
      // Note: Months are zero based
      return moment.months().map((name, index) => {
        return { value: index, name: name }
      })
    },
    yearlyDayOfMonthValue() {
      let date = moment(this.fieldValue, "YYYY-MM-DD").local(true)
      return date.date()
    },
    yearlyMonthValue() {
      let date = moment(this.fieldValue, "YYYY-MM-DD").local(true)
      return date.month()
    },
    displayFieldValue() {
      var value = this.fieldValue

      if(this.isFieldTypeSelect)
        return this.formatLookupName(value, this.fieldLookup)
      if(this.isFieldTypeMultiSelect) {
        return value.map(listValue => this.formatLookupName(listValue, this.fieldLookup)).join(', ')
      }
      if(this.isFieldTypeDayOfMonth)
        return this.formatLookupName(value, this.dayOfMonthLookup)

      if(this.isFieldTypeTime)
        return this.formatTimeOfDay(value)

      if(this.isFieldTypeCurrency)
        return this.formatCurrency(parseFloat(value))
      if(this.isFieldTypeNumber)
        return parseFloat(value)
      if(this.isFieldTypeText)
        return value
      if(this.isFieldTypeTextArea)
        return this.convertNewlinesToBreaks(value)
      if(this.isFieldTypeTagList) {
        if(_.isArray(value))
          return value.join(', ')
        return value
      }
      if(this.isFieldTypeDayOfYear) {
        return moment(value).local(true).format('Do MMMM')
      }

      return ''
    }
  },
  mounted() {
  },
  methods: {
    updateFieldValue(value) {
      this.$emit('update', value)
    },
    updateYearlyDayFieldValue(value) {
      let yearValue = moment().local().year()
      let monthValue = String(this.yearlyMonthValue + 1).padStart(2, '0')
      let dayValue = String(value).padStart(2, '0')

      let dateFmt = `${yearValue}-${monthValue}-${dayValue}`
      if(!moment(dateFmt).isValid()) {
        // Reset to the 1st day of the selected month
        dateFmt = `${yearValue}-${monthValue}-01`
      }

      this.updateFieldValue(dateFmt)
    },
    updateYearlyMonthFieldValue(value) {
      let yearValue = moment().local().year()
      let monthValue = String(parseInt(value) + 1).padStart(2, '0')
      let dayValue = String(this.yearlyDayOfMonthValue).padStart(2, '0')

      let dateFmt = `${yearValue}-${monthValue}-${dayValue}`
      if(!moment(dateFmt).isValid()) {
        // Reset to the 1st day of the selected month
        dateFmt = `${yearValue}-${monthValue}-01`
      }

      this.updateFieldValue(dateFmt)
    },
    insertTextAtCursor(insertText) {
      // Inserts into the input text / text area fields
      var inputComponent = null
      if(this.isFieldTypeCurrency)
        inputComponent = this.$refs.inputCurrencyField
      else if(this.isFieldTypeNumber)
        inputComponent = this.$refs.inputNumberField
      else if(this.isFieldTypeText)
        inputComponent = this.$refs.inputTextField
      else if(this.isFieldTypeTextArea)
        inputComponent = this.$refs.inputTextAreaField

      if(inputComponent) {
        inputComponent.insertTextAtCursor(insertText)
        inputComponent.focus()
      }
    }
  }

}
</script>